import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/EditDark.svg'


const _hoisted_1 = { class: "base-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      class: "icon-edit"
    }, null, -1)
  ]))]))
}